import {Swiper}        from 'swiper';
import {SwiperOptions} from 'swiper/types';

function swissFundDataSlider() {

  const left  = document.getElementById('swiss-fund-data-button-left') as HTMLElement;
  const right = document.getElementById('swiss-fund-data-button-right') as HTMLElement;
  
  let options: SwiperOptions = {
    slidesPerView: 'auto',
    grabCursor: true,
    freeMode: false,
    loop: true,
    slideClass: 'sfd-slide',
    pagination: {
      el: '.sfd-pagination',
      clickable: true,
    },
  }

  let slider = new Swiper('.swiss-fund-data-carousel', options);

  left.addEventListener('click', () => slider.slidePrev());
  right.addEventListener('click', () => slider.slideNext());

}



function swissFundDataIFrames() {

  // DOM elements
  const sfdContainer = document.querySelectorAll('.sfd-container')[0];
  let slideIFramesRaw = document.querySelectorAll('.sfd-slide.sfd-iframe');
  let slideIFrames = Array.prototype.slice.call(slideIFramesRaw) as HTMLIFrameElement[];
  let highlightedIFramesRaw = document.querySelectorAll('.sfd-highlighted .sfd-iframe');
  let highlightedIFrames = Array.prototype.slice.call(highlightedIFramesRaw) as HTMLIFrameElement[];

  // Media query listener
  const mediaQuery = window.matchMedia('(min-width: 992px)');
  mediaQuery.addListener(mqListenerIFrames);
  mqListenerIFrames(mediaQuery);
  
  // Media query listener update function
  function mqListenerIFrames(mediaQuery: MediaQueryList | MediaQueryListEvent) {
    if (mediaQuery.matches) {

      swissFundDataIFramesUpdate(
        Math.floor(sfdContainer.clientWidth / 2) - 15,
        Math.floor(sfdContainer.clientWidth / 3.5),
        highlightedIFrames);
    
      swissFundDataIFramesUpdate(
        Math.floor(sfdContainer.clientWidth * 0.7),
        Math.floor(sfdContainer.clientWidth / 3.5),
        slideIFrames); 
    }
    else {

      swissFundDataIFramesUpdate(
        Math.floor(sfdContainer.clientWidth),
        Math.floor(sfdContainer.clientWidth / 2),
        highlightedIFrames);

      swissFundDataIFramesUpdate(
        Math.floor(sfdContainer.clientWidth) - 15,
        Math.floor(sfdContainer.clientWidth / 2),
        slideIFrames); 
    }
  }

  // iFrame update function
  function swissFundDataIFramesUpdate(width: number, height: number, iFrames: HTMLIFrameElement[]) {
  
    const widthUrl = encodeURIComponent(`&width=${width - 30}`);
    const heightUrl = encodeURIComponent(`&height=${height}`);
  
    for (let iFrame of iFrames) {
      iFrame.src = iFrame.dataset.src + widthUrl + heightUrl;
      iFrame.width = `${width}px`;
      iFrame.height = `${height + 140}px`;
    }
  }
}


swissFundDataIFrames();
swissFundDataSlider();